export const transformApplicationData = (data: any): any => ({
  applicationViewDate: data.appliedJobInfo?.createdAt || null,
  candidateDetails: {
    about: "",
    address: data.candidate?.address || "",
    confirmedDate: null,
    createdAt: data.candidate?.createdAt || null,
    email: data.candidate?.email || "",
    firstName: data.candidate?.firstName || "",
    isRegistered: data.candidate?.isRegistered || false,
    jobTitle: data.candidate?.jobTitle || "",
    lastName: data.candidate?.lastName || "",
    location: data.candidate?.location || "",
    phoneNo: data.candidate?.phoneNo || null,
    privacySettings: data.candidate?.privacySettings || {
      about: "Private",
      experience: "Private",
      skills: "Private",
      education: "Private",
      contact: "Private",
    },
    profilePic: data.candidate?.profilePic || "",
    refNo: data.candidate?.refNo || "",
    shortlisted: false,
    status: data.candidate?.status || "",
    type: data.candidate?.type || null,
    updatedAt: data.candidate?.updatedAt || null,
    userId: data.candidate?.userId || "",
    _id: data.candidate?._id || "",
  },
  candidateId: data.candidate?._id || "",
  coverLetter: data.appliedJobInfo?.coverLetter || "",
  createdAt: data.appliedJobInfo?.createdAt || null,
  cv: data.appliedJobInfo?.cv || "",
  isSkillMatchVisible: data.appliedJobInfo?.isSkillMatchVisible || false,
  jobDetails: {
    createdAt: data.job?.createdAt || null,
    createdBy: data.job?.createdBy || "",
    currency: data.job?.currency || "",
    description: data.job?.description || "",
    extensionNotified: data.job?.extensionNotified || false,
    hasReferral: data.job?.hasReferral || false,
    industryType: data.job?.industryType || "",
    isInternship: data.job?.isInternship || false,
    isSalaryHidden: data.job?.isSalaryHidden || false,
    isStartUp: data.job?.isStartUp || false,
    jobRequirementId: data.job?.jobRequirementId || "",
    jobType: data.job?.jobType || null,
    location: data.job?.location || "",
    positionLevel: data.job?.positionLevel || null,
    publishedDate: null,
    refNo: data.job?.refNo || "",
    referralAmount: null,
    salary: data.job?.salary || { min: 0, max: 0 },
    showCompanyDetails: null,
    status: data.job?.status || null,
    title: data.job?.title || "",
    updatedAt: data.job?.updatedAt || null,
    workPlaceOption: data.job?.workPlaceOption || null,
    _id: data.job?._id || "",
  },
  jobId: data.job?._id || "",
  updatedAt: data.appliedJobInfo?.updatedAt || null,
  viewed: data.appliedJobInfo?.viewed || false,
  _id: data.appliedJobInfo?._id || "",
});
